export default "__VITE_PUBLIC_ASSET__2e135d1f__"